<div class="flex min-h-screen flex-col">
  <div class="z-10 flex h-14 flex-col justify-evenly shadow-sm">
    <div class="bg-background relative flex h-full items-center justify-center">
      <a class="absolute left-2 flex items-center sm:left-12" routerLink="/">
        <mat-icon svgIcon="arrow-left" class="h-8 w-8 cursor-pointer text-primary" />
      </a>

      <div class="flex items-center select-none">
        @if (logoUrl()) {
          <img class="size-7" [src]="logoUrl()" [alt]="appName() || 'Logo'" />
        }
        @if (appName()) {
          <div class="ml-3 text-2xl font-bold">{{ appName() }}</div>
        }
      </div>
    </div>
  </div>

  <div class="flex flex-1 flex-col">
    <router-outlet />
  </div>
</div>
